import React, { useState, useEffect } from 'react';
import api from "../../../services/api";
import { store } from "react-notifications-component";
import TextArea from "../../textarea/text_area_v2";
import InputV2 from "../../input/input_v2";
import SelectV2 from "../../select/select_v2";
import InputBadge from "../../inputBadge";
import { useEquipamentosAplicacao } from "../../../services/equipamentosAplicacao";
import { isTotvs, isOmie } from '../../../services/globalFunctions';
import { hasReceitaSolicitada } from '../../../services/receitaSolicitada';
import { TableRowCellSmall } from './styles';
import { TaglinePSpan } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';


import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
const Relation = ({ ...props }) => {

    const { isCompendio, compendioParams, estado, compendioLoading } = props;

    // Catalogo de equipamentos da conta. O hook compartilha um cache de modulo,
    // entao as varias relacoes da receita fazem um GET so e ficam em sincronia.
    const equipamentosCatalogo = useEquipamentosAplicacao();

    const [isException, setIsException] = useState(false);
    const [loadRelation, setLoadRelation] = useState(false);
    const [relation, setRelation] = useState([]);
    const [isCalculate, setIsCalculate] = useState(false);

    const [optionsFase, setOptionsFase] = useState([]);
    const [fase, setFase] = useState([]);
    const [erroFase, setErroFase] = useState(false);

    const [optionsModalidadeAplicacao, setOptionsModalidadeAplicacao] = useState([]);
    const [modalidadeAplicacao, setModalidadeAplicacao] = useState([]);
    const [erroModalidadeAplicacao, setErroModalidadeAplicacao] = useState(false);

    const [dose, setDose] = useState('');
    const [erroDose, setErroDose] = useState(false);

    const [numeroAplicacoes, setNumeroAplicacoes] = useState('');
    const [erroNumeroAplicacoes, setErroNumeroAplicacoes] = useState(false);

    const [areaTratar, setAreaTratar] = useState('');
    const [erroAreaTratar, setErroAreaTratar] = useState(false);
    const [erroAreaMsg, setErroAreaMsg] = useState('');
    const [disableAreaTratar, setDisableAreaTratar] = useState(false);
    const [loadingArea, setLoadingArea] = useState(false);

    const [quantidadeAdquirir, setQuantidadeAdquirir] = useState('');
    const [erroQuantodadeAdquirir, setErroQuantidadeAdquirir] = useState('');
    const [disableQuantidadeAdquirir, setDisableQuantidadeAdquirir] = useState(false);
    const [unidadeQuantidadeAdquirir, setUnidadeQuantidadeAdquirir] = useState('');
    const [loadingQuantidade, setLoadingQuantidade] = useState(false);

    // Pedido Omie já vem com a quantidade realmente vendida - trava o campo nesse valor em
    // vez de deixar o agrônomo recalcular por área x dose (poderia divergir do que foi
    // faturado na Omie).
    useEffect(() => {
        if (!isOmie() || !props.recipeDraft) return;
        const arr = props.recipeDraft?.agro_prescriptions_relations_orders || [];
        const order = arr[props.index];
        if (!order || order.quantidade_adquirir === null || order.quantidade_adquirir === undefined) return;
        setQuantidadeAdquirir(String(order.quantidade_adquirir).replace('.', ','));
        setUnidadeQuantidadeAdquirir(order.unidade_quantidade_adquirir || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.recipeDraft, props.index]);

    const [volumeCalda, setVolumeCalda] = useState('');

    const [equipamento, setEquipamento] = useState('');

    const [date, setDate] = useState('');

    const [existErro, setExistErro] = useState(false);

    const [load, setLoad] = useState(false)

    const [relationInfo, setRelationInfo] = useState([]);

    const [unidadeAreaTratar, setUnidadeAreaTratar] = useState("");

    const resolveFaseOption = (options, selectedValue) => {
        if (!Array.isArray(options) || options.length === 0) return { value: '', label: '' };

        if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '') {
            const found = options.find((option) => option?.value === selectedValue);
            if (found) return found;
        }

        return { value: '', label: '' };
    };

    const searchRelationId = async (relationId) => {
        props.onLoadingChange && props.onLoadingChange(true);
        try {
            if (relationId !== 0) {
                if (isTotvs()) {
                    try {
                        const responseConfig = await api.get(`/relacoes/buscar-configuracao/${relationId}`);
                        const payloadConfig = responseConfig?.data?.data || responseConfig?.data;
                        const savedConfig = Array.isArray(payloadConfig) ? payloadConfig[0] : payloadConfig;

                        if (savedConfig) {
                            const draftModeId = (() => {
                                const orders = props.recipeDraft?.agro_prescriptions_relations_orders;
                                const order = Array.isArray(orders) ? orders[props.index] : null;
                                const id = order?.application_mode_id ?? order?.aplication_id;
                                return id != null && id !== '' ? Number(id) : null;
                            })();
                            const modeId = draftModeId || (savedConfig.aplication_id ? Number(savedConfig.aplication_id) : null);
                            if (modeId) {
                                setModalidadeAplicacao({ value: modeId, label: '' });
                            }
                            if (savedConfig.dosagem !== undefined && savedConfig.dosagem !== null) {
                                setDose(`${savedConfig.dosagem}`);
                            }
                            if (savedConfig.num_aplicacao !== undefined && savedConfig.num_aplicacao !== null) {
                                setNumeroAplicacoes(savedConfig.num_aplicacao);
                            }
                            if (savedConfig.area_tratar !== undefined && savedConfig.area_tratar !== null) {
                                setAreaTratar(`${savedConfig.area_tratar}`);
                            }
                            const qtdAdquirir = savedConfig.qtd_adquiri ?? savedConfig.qtd_adquirir;
                            if (qtdAdquirir !== undefined && qtdAdquirir !== null) {
                                setQuantidadeAdquirir(`${qtdAdquirir}`);
                            }
                            if (savedConfig.equip_aplicacao !== undefined && savedConfig.equip_aplicacao !== null) {
                                setEquipamento(savedConfig.equip_aplicacao);
                            }
                        }
                    } catch (error) {
                        // Sem bloqueio: se nao houver configuracao salva, segue fluxo padrao.
                    }
                }

                const response = await api.get(`/relacoes/${relationId}`);
                if (response.data.data) {
                    const responseRelation = response.data.data;


                    setRelation(responseRelation);
                    setLoadRelation(true);
                    mountRelationOptions(responseRelation);
                    setUnidadeQuantidadeAdquirir(responseRelation.unidade_dosagem.unidade_quantidade_adquirir);
                    setUnidadeAreaTratar(responseRelation.unidades_area_tratar ? responseRelation.unidades_area_tratar : "Ha");

                    if (responseRelation.agro_relations_exceptions && responseRelation.agro_relations_exceptions.length > 0) {
                        if (props.relationInfo !== undefined && props.relationInfo.optionsFase !== undefined && props.relationInfo.optionsFase.length > 0) {
                            setOptionsFase(props.relationInfo.optionsFase)
                        } else {
                            let optionsExceptions = [];
                            let agroExceptionsName = '';

                            responseRelation.agro_relations_exceptions.map((ex, j) => {
                                agroExceptionsName = agroExceptionsName + `${ex.agro_exception.nome}; `;
                            })

                            optionsExceptions = [...optionsExceptions, { value: relationId, label: agroExceptionsName }]

                            setOptionsFase(optionsExceptions);
                            setFase(resolveFaseOption(optionsExceptions, relationId));
                        }

                        setIsException(true);

                    }

                    if (responseRelation.calculo_automatico === true) {
                        setIsCalculate(true);
                    } else {
                        setIsCalculate(false);
                    }
                }
            }
        } catch (error) {
            const message = error?.response?.data?.errors || 'Erro ao carregar relação.';
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            props.onLoadingChange && props.onLoadingChange(false);
        }
    }

    const setPrescriptionType = (type) => {
        if (type === 1) {
            //sem fase
            setIsException(false);
            searchRelationId(props.relation);
        } else if (type === 2) {
            //com fase            
            let optionsExceptions = [];

            if (typeof props.relation === 'number') {
                //Fase selecionada
                // setOptionsFase(props.relationInfo.optionsExceptions);
                if (optionsFase.length > 0) {
                    setFase(resolveFaseOption(optionsFase, props.relation));
                } else {
                    setFase(props.relationInfo.fase);
                }
                searchRelationId(props.relation);

            } else {
                //Necessário selecionar uma fase
                //Montando opções do campo
                props.relation.map((r, i) => {
                    let agroExceptionsName = '';
                    (r.relacao.agro_relations_exceptions || []).map((ex, j) => {
                        agroExceptionsName = agroExceptionsName + `${ex.agro_exceptions.nome}; `;
                    })

                    optionsExceptions = [...optionsExceptions, { value: r.relacao.id, label: agroExceptionsName }]
                })

                setOptionsFase(optionsExceptions);
                setFase({ value: '', label: '' });

                if (isCompendio && compendioParams) {
                    if (compendioLoading === false) {
                        if (compendioParams.relacaoId) {
                            optionsExceptions.map((f) => {
                                if (f.value === parseInt(compendioParams.relacaoId)) {
                                    changeException(f);
                                }
                            });
                        }
                    }
                }

                setLoadRelation(true);
            }

            setIsException(true);

        }
    }

    const calculo = async () => {

        if (isException === false) {
            if (dose && numeroAplicacoes) {
                let num_apli = parseInt(numeroAplicacoes);
                let Dose = parseFloat(dose);

                if (areaTratar && !quantidadeAdquirir) {
                    //calcular pela área
                    let area = (estado.value === 'SC' || estado.value === 'PR') ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                    setLoadingQuantidade(true);

                    const payload = {
                        estado: estado.value,
                        agro_relation_id: relation.id,
                        dose: Dose,
                        numero_aplicacoes: num_apli,
                        quantidade_adquirir: 0,
                        area_tratar: parseFloat(area)
                    };

                    try {
                        const response = await api.post(`/calculo`, payload);
                        let resultado = response.data.data;
                        changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));
                        setAreaTratar(area);
                        setLoadingQuantidade(false);

                    } catch (error) {
                        setLoadingQuantidade(false);
                    }


                } else if (!areaTratar && quantidadeAdquirir) {
                    //calcular pela quantidade
                    setLoadingArea(true);

                    let quantidade = arredondarQuantidade(quantidadeAdquirir);

                    const payload = {
                        estado: estado.value,
                        agro_relation_id: relation.id,
                        dose: Dose,
                        numero_aplicacoes: num_apli,
                        quantidade_adquirir: parseFloat(quantidade),
                        area_tratar: 0
                    };

                    try {
                        const response = await api.post(`/calculo`, payload);
                        let resultado = response.data.data;

                        let resArea = (estado.value === 'SC' || estado.value === 'PR') ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);
                        changeAreaTratar(resArea);
                        setQuantidadeAdquirir(quantidade);
                        setLoadingArea(false);

                    } catch (error) {
                        setLoadingArea(false);
                    }
                } else {
                    if (areaTratar && quantidadeAdquirir) {
                        if (disableAreaTratar) {
                            //calcular pela quantidade
                            setLoadingArea(true);

                            let quantidade = arredondarQuantidade(quantidadeAdquirir);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: relation.id,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: parseFloat(quantidade),
                                area_tratar: 0
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);

                                let resultado = response.data.data;
                                let resArea = (estado.value === 'SC' || estado.value === 'PR') ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);

                                changeAreaTratar(resArea);
                                setQuantidadeAdquirir(quantidade);
                                setLoadingArea(false);

                            } catch (error) {
                                setLoadingArea(false);
                            }

                        } else if (disableQuantidadeAdquirir) {
                            //calcular pela área
                            setLoadingQuantidade(true);
                            let area = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: relation.id,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: 0,
                                area_tratar: parseFloat(area)
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;
                                setAreaTratar(area);

                                changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));

                                setLoadingQuantidade(false);

                            } catch (error) {

                            }

                        }
                    } else {
                        if (disableAreaTratar) {
                            //calcular pela quantidade
                            setLoadingArea(true);

                            let quantidade = arredondarQuantidade(quantidadeAdquirir);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: relation.id,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: parseFloat(quantidade),
                                area_tratar: 0
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);

                                let resultado = response.data.data;
                                let resArea = (estado.value === 'SC' || estado.value === 'PR') ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);

                                changeAreaTratar(resArea);
                                setQuantidadeAdquirir(quantidade);
                                setLoadingArea(false);

                            } catch (error) {
                                setLoadingArea(false);
                            }

                        } else if (disableQuantidadeAdquirir) {
                            //calcular pela área
                            setLoadingQuantidade(true);
                            let area = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: relation.id,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: 0,
                                area_tratar: parseFloat(area)
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;
                                setAreaTratar(area);
                                changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));
                                setLoadingQuantidade(false);
                            } catch (error) {
                                setLoadingQuantidade(false);
                            }

                        }
                    }
                }
            } else {
                if (!dose && !numeroAplicacoes) {
                    setErroDose(true);
                    setErroNumeroAplicacoes(true);

                    store.addNotification({
                        title: "Erro!",
                        message: "Informe a dose e o número de aplicações para realizar o cálculo automático!",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    if (!dose) {
                        setErroDose(true);
                        store.addNotification({
                            title: "Erro!",
                            message: "Informe a dose para realizar o cálculo automático!",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }

                    if (!numeroAplicacoes) {
                        setErroNumeroAplicacoes(true);
                        store.addNotification({
                            title: "Erro!",
                            message: "Informe o número de aplicações para realizar o cálculo automático!",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }
                }
            }
        } else {
            if (dose && numeroAplicacoes) {
                let num_apli = parseInt(numeroAplicacoes);
                let Dose = parseFloat(dose);

                if (areaTratar && !quantidadeAdquirir) {
                    //calcular pela área
                    setLoadingQuantidade(true);
                    let area = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                    const payload = {
                        estado: estado.value,
                        agro_relation_id: fase.value,
                        dose: Dose,
                        numero_aplicacoes: num_apli,
                        quantidade_adquirir: 0,
                        area_tratar: parseFloat(area)
                    };

                    try {
                        const response = await api.post(`/calculo`, payload);
                        let resultado = response.data.data;

                        setAreaTratar(area);
                        changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));

                        setLoadingQuantidade(false);

                    } catch (error) {
                        setLoadingQuantidade(false);
                    }


                } else if (!areaTratar && quantidadeAdquirir) {
                    //calcular pela quantidade
                    setLoadingArea(true);

                    let quantidade = arredondarQuantidade(quantidadeAdquirir);

                    const payload = {
                        estado: estado.value,
                        agro_relation_id: fase.value,
                        dose: Dose,
                        numero_aplicacoes: num_apli,
                        quantidade_adquirir: parseFloat(quantidade),
                        area_tratar: 0
                    };

                    try {
                        const response = await api.post(`/calculo`, payload);
                        let resultado = response.data.data;

                        let resArea = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);

                        changeAreaTratar(resArea);
                        setQuantidadeAdquirir(quantidade);
                        setLoadingArea(false);

                    } catch (error) {
                        setLoadingArea(false);

                    }
                } else {
                    if (areaTratar && quantidadeAdquirir) {
                        if (disableAreaTratar) {
                            //calcular pela quantidade
                            setLoadingArea(true);
                            let quantidade = arredondarQuantidade(quantidadeAdquirir);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: fase.value,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: parseFloat(quantidade),
                                area_tratar: 0
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;

                                let resArea = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);

                                changeAreaTratar(resArea);
                                setQuantidadeAdquirir(quantidade);

                                setLoadingArea(false);
                            } catch (error) {
                                setLoadingArea(false);
                            }

                        } else if (disableQuantidadeAdquirir) {
                            //calcular pela área
                            setLoadingQuantidade(true);

                            let area = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: fase.value,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: 0,
                                area_tratar: parseFloat(area)
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;
                                setAreaTratar(area)

                                changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));
                                setLoadingQuantidade(false);
                            } catch (error) {
                                setLoadingQuantidade(false);

                            }

                        }
                    } else {
                        if (disableAreaTratar) {
                            //calcular pela quantidade
                            setLoadingArea(true);

                            let quantidade = arredondarQuantidade(quantidadeAdquirir);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: fase.value,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: parseFloat(quantidade),
                                area_tratar: 0
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;

                                let resArea = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(resultado.area_tratar).toFixed(1) : parseFloat(resultado.area_tratar).toFixed(2);

                                changeAreaTratar(resArea);
                                setQuantidadeAdquirir(quantidade);
                                setLoadingArea(false);

                            } catch (error) {
                                setLoadingArea(false);
                            }

                        } else if (disableQuantidadeAdquirir) {
                            //calcular pela área
                            setLoadingQuantidade(true);

                            let area = estado.value === 'SC' || estado.value === 'PR' ? parseFloat(areaTratar).toFixed(1) : parseFloat(areaTratar).toFixed(2);

                            const payload = {
                                estado: estado.value,
                                agro_relation_id: fase.value,
                                dose: Dose,
                                numero_aplicacoes: num_apli,
                                quantidade_adquirir: 0,
                                area_tratar: parseFloat(area)
                            };

                            try {
                                const response = await api.post(`/calculo`, payload);
                                let resultado = response.data.data;

                                changeQuantidadeAdquirir(arredondarQuantidade(resultado.quantidade_adquirir));

                                setAreaTratar(area);
                                setLoadingQuantidade(false);

                            } catch (error) {
                                setLoadingQuantidade(false);
                            }
                        }
                    }
                }
            } else {
                if (!dose && !numeroAplicacoes) {
                    setErroDose(true);
                    setErroNumeroAplicacoes(true);

                    store.addNotification({
                        title: "Erro!",
                        message: "Informe a dose e o número de aplicações para realizar o cálculo automático!",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    if (!dose) {
                        setErroDose(true);
                        store.addNotification({
                            title: "Erro!",
                            message: "Informe a dose para realizar o cálculo automático!",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }

                    if (!numeroAplicacoes) {
                        setErroNumeroAplicacoes(true);
                        store.addNotification({
                            title: "Erro!",
                            message: "Informe o número de aplicações para realizar o cálculo automático!",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }
                }
            }
        }
    }

    const formatOptionsAplicacao = (options) => {
        let format = [];

        options.map(opcao => {
            const op = opcao.agro_aplication_modes;
            if (estado.value === 'CE' || estado.value === 'RS') {
                if (op.estados_proibidos !== null) {
                    if (op.estados_proibidos.indexOf(estado.value) == -1) {
                        format = [...format, { value: op.id, label: op.nome }];
                    }
                } else {
                    format = [...format, { value: op.id, label: op.nome }];
                }
            } else {
                format = [...format, { value: op.id, label: op.nome }];
            }
        });
        return format;
    }

    const mountRelationOptions = (relation) => {

        const modos = formatOptionsAplicacao(relation.modo_aplicacao);
        setOptionsModalidadeAplicacao(modos);

        const orders = props.recipeDraft?.agro_prescriptions_relations_orders;
        const order = Array.isArray(orders) ? orders[props.index] : null;
        const draftModeId = order?.application_mode_id ?? order?.aplication_id;
        if (draftModeId != null && draftModeId !== '') {
            const selected = modos.find((apli) => Number(apli.value) === Number(draftModeId));
            if (selected) {
                changeModoAplicacao(selected);
                return;
            }
        }

        if (isCompendio && compendioParams) {
            modos.map((apli) => {
                if (apli.value === parseInt(compendioParams.modoAplicacao)) {
                    changeModoAplicacao(apli);
                }
            })
        }
    }

    const changeException = (value) => {
        setFase(value);
        setErroFase(false);
        // props.updateRelationId(value.value);
    }

    const changeModoAplicacao = (data) => {
        setModalidadeAplicacao(data);
        setErroModalidadeAplicacao(false);

        if (data.value === 10) {
            changeVolumeCalda(true);
        } else {
            changeVolumeCalda(false);
        }
    }

    const changeDose = (value) => {
        if (dose !== value) {
            let v = `${value}`;
            if (v) {
                setDose(v.replaceAll(',', '.'));
            } else {
                setDose('');
            }
        }
    }

    const validaDose = (value, minimo, maximo) => {
        if (value) {
            value = parseFloat(value);

            setDose(value);

            if (value >= minimo && value <= maximo) {
                setErroDose(false);

                // No Omie a quantidade vem pré-preenchida do pedido (sem passar pelo blur
                // do campo) - sem essa exceção, área nunca calcularia sozinha pra esse plano.
                if (numeroAplicacoes && quantidadeAdquirir && (areaTratar || isOmie())) {
                    if (!areaTratar) {
                        // Área foi calculada a partir da quantidade - trava, mesmo padrão de validaQuantidade.
                        setDisableAreaTratar(true);
                    }
                    calculo();
                }
            } else {
                setErroDose(true);
            }
        } else {
            setDose('');
        }
    }

    const changeNumeroAplicacoes = (value, min, max) => {
        if (numeroAplicacoes !== value) {

            if (value < min || value > max) {
                setExistErro(true);
            }

            setNumeroAplicacoes(value);
        }
    }

    const validaNumeroAplicacao = (value, minimo, maximo) => {
        if (value) {
            value = parseInt(value);

            setNumeroAplicacoes(value);

            if (value >= minimo && value <= maximo) {
                setErroNumeroAplicacoes(false);
                // Mesma exceção Omie de validaDose acima.
                if (dose && quantidadeAdquirir && (areaTratar || isOmie())) {
                    if (!areaTratar) {
                        setDisableAreaTratar(true);
                    }
                    calculo();
                }
            } else {
                setErroNumeroAplicacoes(true);
                setExistErro(true);
            }
        } else {
            setNumeroAplicacoes('');
        }

    }

    const changeAreaTratar = (value) => {
        value = `${value}`;
        if (value) {
            setAreaTratar(value.replaceAll(',', '.'));
            setErroAreaTratar(false);
            setErroAreaMsg('');
        } else {
            setAreaTratar('');
        }

        if (value === 0 || value === '0' || value === '0.0') {
            setErroAreaTratar(true);
            setErroAreaMsg('A área a tratar deve ser maior que zero');
        } else if (value < 0) {
            setErroAreaTratar(true);
            setErroAreaMsg('A área a tratar deve ser maior que zero');
        } else {
            setErroAreaTratar(false);
            setErroAreaMsg('');
        }
    }

    const validaArea = () => {
        if (areaTratar) {
            if (!quantidadeAdquirir) {
                if (!isCalculate) {
                    let area;

                    if (estado.value === 'SC' || estado.value === 'PR') {
                        area = parseFloat(areaTratar).toFixed(1);
                    } else {
                        area = parseFloat(areaTratar).toFixed(2);
                    }

                    setAreaTratar(area);
                    store.addNotification({
                        title: "Aviso!",
                        message: "O cálculo da Quantidade a adquirir e Área a tratar deve ser feito manualmente para esta unidade de medida",
                        type: "warning",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    setDisableQuantidadeAdquirir(true);
                    calculo();
                }
            } else {
                if (isCalculate) {
                    calculo();
                } else {
                    let area;
                    if (estado.value === 'SC' || estado.value === 'PR') {
                        area = parseFloat(areaTratar).toFixed(1);
                    } else {
                        area = parseFloat(areaTratar).toFixed(2);
                    }
                    setAreaTratar(area);
                }
            }
        } else {
            setDisableQuantidadeAdquirir(false);
        }

    }

    /**
     * Arredonda a quantidade a adquirir: até 4 casas decimais (SC: 1 casa),
     * sem zeros à direita, para não alterar quantidades pequenas (ex.: 0,025 kg).
     */
    const arredondarQuantidade = (valor) => {
        const numero = parseFloat(String(valor).replace(',', '.'));
        if (isNaN(numero)) return '';
        const casas = estado?.value === 'SC' ? 1 : 4;
        return String(parseFloat(numero.toFixed(casas)));
    }

    const changeQuantidadeAdquirir = (value) => {
        if (value) {
            setQuantidadeAdquirir(value.replaceAll(',', '.'));
            setErroQuantidadeAdquirir(false);
        } else {
            setQuantidadeAdquirir('');
        }
    }

    const validaQuantidade = () => {
        if (quantidadeAdquirir) {
            if (!areaTratar) {
                if (!isCalculate) {
                    const quantidade = arredondarQuantidade(quantidadeAdquirir);
                    setQuantidadeAdquirir(quantidade);
                    store.addNotification({
                        title: "Aviso!",
                        message: "O cálculo da Quantidade a adquirir e Área a tratar deve ser feito manualmente para esta unidade de medida",
                        type: "warning",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                } else {
                    setDisableAreaTratar(true);
                    calculo();
                }
            } else {
                if (isCalculate) {
                    calculo();
                } else {
                    const quantidade = arredondarQuantidade(quantidadeAdquirir);

                    setQuantidadeAdquirir(quantidade);
                }
            }
        } else {
            setDisableAreaTratar(false);
        }

    }

    const changeVolumeCalda = (isAereo) => {
        if (relation !== null) {
            if (isAereo) {
                validateVolumeCalda(relation.calda_aerea);
            } else {
                validateVolumeCalda(relation.calda_terrestre);
            }
        }
    }

    const changeEquipamento = (value) => {
        setEquipamento(value);

    }

    const setInitialDate = () => {
        if (props.index === 0) {
            let now = new Date();
            let day = now.getDate();
            let month = now.getMonth();   //valores de 0 a 11, sendo 0 janeiro e 11 dezembro
            month = month + 1;
            let year = now.getFullYear();

            if (day <= 9) {
                day = "0" + day;
            }

            if (month <= 9) {
                month = "0" + month;
            }
            let date = "" + year + "-" + month + "-" + day;
            setDate(date);
        } else {
            setDate(props.date);

        }
    }

    const changeDate = (value) => {
        setDate(value);
    }

    const loadInfo = (relation) => {

        if (areaTratar === '') {
            setAreaTratar(relation.areaTratar);
        }

        if (date === '') {
            setDate(relation.date);
        }

        if (dose === '') {
            setDose(relation.dose);
        }

        if (equipamento === '') {
            setEquipamento(relation.equipamento);
        }
        
        if (relation.fase) {
            if (typeof relation.fase !== 'object') {
                setFase({ value: relation.fase, label: '' });
            } else {
                setFase(relation.fase);
            }
        } else if (!fase || !fase.value) {
            setFase({ value: '', label: '' });
        }

        if (isException === '') {
            setIsException(relation.isException);
        }

        if (modalidadeAplicacao.length === 0) {
            setModalidadeAplicacao(relation.modalidadeAplicacao);
        }

        if (numeroAplicacoes === '') {
            setNumeroAplicacoes(relation.numeroAplicacoes);
        }

        if (optionsFase.length === 0) {
            setOptionsFase(relation.optionsFase);
        }

        if (quantidadeAdquirir === '') {
            setQuantidadeAdquirir(relation.quantidadeAdquirir);
        }

        if (unidadeQuantidadeAdquirir === '') {
            setUnidadeQuantidadeAdquirir(relation.unidadeQuantidadeAdquirir);
        }

        if (volumeCalda === '') {
            setVolumeCalda(relation.volumeCalda)
        }
    }

    const validateVolumeCalda = (e) => {
        setVolumeCalda(e)
    }

    useEffect(() => {
        if (typeof props.relation === 'number') {
            if (props.relationInfo) {
                if (props.relationInfo.fase) {
                    if (props.relationInfo.fase.value) {
                        setPrescriptionType(2);
                    } else {
                        setPrescriptionType(1);
                    }
                } else {
                    setPrescriptionType(1);
                }
            } else {
                setPrescriptionType(1);
            }
        } else if (typeof props.relation === 'object') {
            setPrescriptionType(2);
        }
        setInitialDate()
    }, [props.relation]);

    useEffect(() => {

        if (props.relationInfo) {
            if (load === false) {
                setLoad(true);

                setTimeout(() => {
                    setRelationInfo(props.relationInfo);
                }, 500);
            }
        }
    }, [props.relationInfo])

    useEffect(() => {
        if (relationInfo !== null && relationInfo.length !== 0) {
            loadInfo(relationInfo);
        }

    }, [relationInfo])

    useEffect(() => {
        if (areaTratar === 0 || areaTratar === '0' || areaTratar === '0.0') {
            setErroAreaTratar(true);
            setErroAreaMsg('A área a tratar deve ser maior que zero');
        } else if (areaTratar < 0) {
            setErroAreaTratar(true);
            setErroAreaMsg('A área a tratar deve ser maior que zero');
        } else {
            setErroAreaTratar(false);
            setErroAreaMsg('');
        }
    }, [areaTratar])

    useEffect(() => {
        if (compendioParams) {

            if (compendioParams.relacaoId) {
                setFase({ value: parseInt(compendioParams.relacaoId), label: '' });
            }
            if (compendioParams.modoAplicacao) {

                // Extrai o valor numérico (tratando caso já venha como número ou como string)
                const modoValue = typeof compendioParams.modoAplicacao === 'object'
                    ? parseInt(compendioParams.modoAplicacao.value)
                    : parseInt(compendioParams.modoAplicacao);

                // Encontra o modo correspondente nas opções
                const modoEncontrado = optionsModalidadeAplicacao.find(
                    option => option.value === modoValue
                );

                // Só seta se achou correspondência real - setar com label vazio (modo
                // sugerido não existe pra essa relação, ou opções ainda não carregaram)
                // deixava o .value preenchido e o checkmark marcava completo mesmo com o
                // select aparecendo vazio pro usuário. Sem match, fica vazio até escolher
                // manual - o useEffect roda de novo quando optionsModalidadeAplicacao mudar.
                if (modoEncontrado) {
                    setModalidadeAplicacao({ value: modoValue, label: modoEncontrado.label });
                }
            } else {
            }

            if (
                compendioParams.dose &&
                compendioParams.numApli &&
                compendioParams.area &&
                compendioParams.quantidade
            ) {
                changeDose(compendioParams.dose);
                changeNumeroAplicacoes(compendioParams.numApli);
                changeAreaTratar(compendioParams.area);
                changeQuantidadeAdquirir(compendioParams.quantidade);
            } else {
                if (compendioParams.relacaoId) {
                    if (isException === '') {
                        if (typeof props.relation === 'object') {
                            setFase({ value: parseInt(compendioParams.relacaoId) });
                            setIsException(true);
                        }
                    }
                }
            }
        }
    }, [compendioParams, optionsModalidadeAplicacao]);


    useEffect(() => {
        if (isException === true && Array.isArray(optionsFase) && optionsFase.length === 1 && (!fase || !fase.value)) {
            changeException(optionsFase[0]);
        }
    }, [isException, optionsFase, fase]);

    // Mesmo raciocínio da Fase acima: quando o compêndio só permite 1 modo de aplicação,
    // o checkmark (isRelationComplete, em step1/index.js) já considerava isso completo,
    // mas o campo real usado no envio (modalidadeAplicacao/formatAplicationModesIds em
    // addLote.js) nunca era preenchido de fato - dava "arrays devem ter mesma quantidade
    // de índices" no backend. Auto-seleciona pra sincronizar as duas fontes.
    useEffect(() => {
        if (Array.isArray(optionsModalidadeAplicacao) && optionsModalidadeAplicacao.length === 1 && (!modalidadeAplicacao || !modalidadeAplicacao.value)) {
            changeModoAplicacao(optionsModalidadeAplicacao[0]);
        }
    }, [optionsModalidadeAplicacao, modalidadeAplicacao]);

    useEffect(() => {
        if (erroFase || erroModalidadeAplicacao || erroAreaTratar || erroDose || erroNumeroAplicacoes || erroQuantodadeAdquirir) {
            setExistErro(true);
        } else {
            setExistErro(false);
        }
    }, [erroFase, erroModalidadeAplicacao, erroAreaTratar, erroDose, erroNumeroAplicacoes, erroQuantodadeAdquirir])

    useEffect(() => {
        if (isException === true) {
            const payloadResponse = {
                index: props.index,
                relationId: fase?.value ?? 0,
                fase,
                optionsFase,
                modalidadeAplicacao,
                dose: dose !== undefined && dose !== 'undefined' ? dose : '',
                numeroAplicacoes: numeroAplicacoes !== undefined && numeroAplicacoes !== 'undefined' ? numeroAplicacoes : '',
                areaTratar,
                quantidadeAdquirir,
                unidadeQuantidadeAdquirir,
                volumeCalda,
                equipamento,
                date,
                erro: existErro,
                isException
            };
            props.updateRelationInfo(payloadResponse);
        } else if (isException === false) {
            const payloadResponse = {
                index: props.index,
                relationId: props.relation,
                fase,
                optionsFase,
                modalidadeAplicacao,
                dose,
                numeroAplicacoes,
                areaTratar,
                quantidadeAdquirir,
                unidadeQuantidadeAdquirir,
                volumeCalda,
                equipamento,
                date,
                erro: existErro,
                isException
            };
            props.updateRelationInfo(payloadResponse);
        }
    }, [
        props.compendioLoading,
        modalidadeAplicacao,
        dose,
        numeroAplicacoes,
        areaTratar,
        quantidadeAdquirir,
        unidadeQuantidadeAdquirir,
        equipamento,
        date,
        volumeCalda,
        fase,
        optionsFase
    ]);


    useEffect(() => {
        if (fase && fase.value && isException === true) {

            const payloadResponse = {
                index: props.index,
                relationId: fase.value,
                fase,
                optionsFase,
                modalidadeAplicacao,
                dose: dose !== undefined && dose !== 'undefined' ? dose : '',
                numeroAplicacoes: numeroAplicacoes !== undefined && numeroAplicacoes !== 'undefined' ? numeroAplicacoes : '',
                areaTratar,
                quantidadeAdquirir,
                unidadeQuantidadeAdquirir,
                volumeCalda,
                equipamento,
                date,
                erro: existErro,
                isException
            }

            props.updateRelationInfo(payloadResponse);
            props.updateRelationId(fase.value);

        }
    }, [fase, optionsFase, isException])

    return (
        <>
            {isException === true && relation.length === 0 ? (
                <>
                    {isException === true ? (
                        <SelectV2
                            marginBottom="0"
                            name="fase"
                            className="select"
                            label="Fase/Tipo de solo"
                            id="fase"
                            value={fase.value || fase}
                            disabled={!isException}
                            erro={optionsFase ? erroFase : false}
                            onChange={e => changeException(e)}
                            options={optionsFase}
                            selectUniqueOption={true}
                        />
                    ) : (null)}
                </>
            ) : (
                <>
                    {loadRelation ? (
                        <>
                            {isException === true && (
                                <SelectV2
                                    marginBottom="48px"
                                    name="fase"
                                    className="select"
                                    label="Fase/Tipo de solo"
                                    id="fase"
                                    value={fase?.value ?? ''}
                                    disabled={!isException}
                                    erro={optionsFase ? isException === true ? erroFase : false : false}
                                    onChange={e => changeException(e)}
                                    options={optionsFase}
                                    selectUniqueOption={true}
                                />
                            )}

                            {!props.hideEpocaAplicacao && (
                                <TextArea
                                    name="epoca"
                                    label="Época de aplicação"
                                    labelWithAsterisk={true}
                                    id="epoca"
                                    value={relation.epoca_aplicacao || ''}
                                    maxlength="number"
                                    marginBottom="34px"
                                />
                            )}

                            <SelectV2
                                marginBottom="48px"
                                name="aplication"
                                className="select"
                                label="Modo de aplicação"
                                labelWithAsterisk={true}
                                id="aplication"
                                disabled={false}
                                value={modalidadeAplicacao?.value ?? ''}
                                onChange={e => changeModoAplicacao(e)}
                                erro={erroModalidadeAplicacao}
                                options={optionsModalidadeAplicacao}
                                selectUniqueOption={true}
                            />

                            <InputV2
                                marginBottom="36px"
                                id="dose"
                                minHeight="50px"
                                value={dose || ''}
                                min={relation.dosagem_minima || ''}
                                max={relation.dosagem_maxima || ''}
                                updateValue={(e) => validaDose(`${e}`, relation.dosagem_minima, relation.dosagem_maxima)}
                                label="Dose"
                                labelWithAsterisk={true}
                                onChange={(e) => changeDose(e)}
                                onBlur={(e) => validaDose(e.target.value, relation.dosagem_minima, relation.dosagem_maxima)}
                                unidade={relation.unidade_dosagem.unidade || ''}
                                legenda={relation.dosagem_minima && relation.dosagem_maxima ? `De ${relation.dosagem_minima} a ${relation.dosagem_maxima} ${relation.unidade_dosagem.unidade}` : `Selecione o tipo de solo para adicionar a dose`}
                                erro={erroDose}
                                messageErro={relation.dosagem_minima && relation.dosagem_maxima ? `Dose inválida, informe um valor entre ${relation.dosagem_minima} e ${relation.dosagem_maxima}` : `Selecione o tipo de solo para adicionar a dose`}
                            />

                            <InputV2
                                id="numero_aplicacoes"
                                marginBottom={relation.numero_aplicacoes_minimo && relation.numero_aplicacoes_maximo ? '36px' : '36px'}
                                minHeight="50px"
                                value={numeroAplicacoes}
                                min={relation.numero_aplicacoes_minimo || ''}
                                max={relation.numero_aplicacoes_maximo || ''}
                                updateValue={(e) => validaNumeroAplicacao(e, relation.numero_aplicacoes_minimo, relation.numero_aplicacoes_maximo)}
                                onChange={(e) => changeNumeroAplicacoes(e)}
                                onBlur={e => validaNumeroAplicacao(e.target.value, relation.numero_aplicacoes_minimo, relation.numero_aplicacoes_maximo)}
                                label="Número de aplicações"
                                labelWithAsterisk={true}
                                // type="number"
                                inputmode="numeric"
                                legenda={relation.numero_aplicacoes_minimo && relation.numero_aplicacoes_maximo ? relation.numero_aplicacoes_minimo === relation.numero_aplicacoes_maximo ? `De ${relation.numero_aplicacoes_minimo} a ${relation.numero_aplicacoes_maximo} aplicação` : `De ${relation.numero_aplicacoes_minimo} a ${relation.numero_aplicacoes_maximo} aplicações` : `Selecione o tipo de solo para adicionar o número de aplicações`}
                                erro={erroNumeroAplicacoes || ''}
                                messageErro={relation.numero_aplicacoes_minimo && relation.numero_aplicacoes_maximo ? `Informe um valor entre ${relation.numero_aplicacoes_minimo} e ${relation.numero_aplicacoes_maximo}` : `Selecione o tipo de solo para adicionar o número de aplicações`}
                            />

                            {!props.hideAreaTratar && (
                                <InputV2
                                    marginBottom="36px"
                                    id="areatratar"
                                    minHeight="50px"
                                    onChange={e => changeAreaTratar(e)}
                                    onBlur={() => validaArea()}
                                    label="Área a tratar"
                                    labelWithAsterisk={true}
                                    // type="number"
                                    inputmode="numeric"
                                    value={areaTratar}
                                    erro={erroAreaTratar}
                                    disabled={disableAreaTratar}
                                    unidade={unidadeAreaTratar}
                                    loading={loadingArea}
                                    messageErro={erroAreaMsg}
                                />
                            )}

                            {!props.hideQuantidadeAdquirir && (
                                isTotvs && props.recipeDraft && hasReceitaSolicitada() ? (
                                    <div style={{width: '100%', height: 'auto', display: 'flex', gap: '16px'}}>
                                        <InputV2
                                            marginBottom="20px"
                                            id="quantidade"
                                            minHeight="50px"
                                            onChange={e => changeQuantidadeAdquirir(e)}
                                            onBlur={(e) => validaQuantidade(e.target.value)}
                                            label="Quantidade a adquirir"
                                            labelWithAsterisk={true}
                                            // type="number"
                                            inputmode="numeric"
                                            value={quantidadeAdquirir}
                                            erro={erroQuantodadeAdquirir}
                                            disabled={disableQuantidadeAdquirir}
                                            unidade={unidadeQuantidadeAdquirir}
                                            loading={loadingQuantidade}
                                        />

                                        {isOmie() && (
                                            <TableRowCellSmall style={{ flex: '0 0 auto' }}>
                                                <TaglinePSpan color={theme.colors.gray.Cinza_2}>
                                                    Quantidade <br/> vendida:
                                                    {(() => {
                                                        const arr = props.recipeDraft?.agro_prescriptions_relations_orders || [];
                                                        const order = arr[props.index];
                                                        if (!order) return '';
                                                        const q = String(order.quantidade_adquirir || '').replace('.', ',');
                                                        const u = order.unidade_quantidade_adquirir || '';
                                                        return ` ${q} ${u}`;
                                                    })()}
                                                </TaglinePSpan>
                                            </TableRowCellSmall>
                                        )}
                                    </div>
                                ) : (
                                    <InputV2
                                        marginBottom="36px"
                                        id="quantidade"
                                        minHeight="50px"
                                        onChange={e => changeQuantidadeAdquirir(e)}
                                        onBlur={(e) => validaQuantidade(e.target.value)}
                                        label="Quantidade a adquirir"
                                        labelWithAsterisk={true}
                                        // type="number"
                                        inputmode="numeric"
                                        value={quantidadeAdquirir}
                                        erro={erroQuantodadeAdquirir}
                                        disabled={disableQuantidadeAdquirir}
                                        unidade={unidadeQuantidadeAdquirir}
                                        loading={loadingQuantidade}
                                    />
                                )
                            )}

                            {!props.hideVolumeCalda && (
                                <InputV2
                                    marginBottom="36px"
                                    id="volumeCalda"
                                    minHeight="50px"
                                    value={volumeCalda}
                                    label="Volume de Calda"
                                    labelWithAsterisk={true}
                                    legenda={volumeCalda === '' ? 'Informe o valor de acordo com a bula!' : ''}
                                    onChange={(e) => validateVolumeCalda(e)}
                                />
                            )}

                            <InputBadge
                                marginBottom="36px"
                                minHeight="50px"
                                label="Equipamento de aplicação"
                                placeholder="Busque ou digite para criar"
                                value={equipamento}
                                onChange={changeEquipamento}
                                options={equipamentosCatalogo.equipamentos}
                                loading={equipamentosCatalogo.loading}
                                erro={equipamentosCatalogo.erro}
                                onCreate={equipamentosCatalogo.criar}
                                onEdit={equipamentosCatalogo.editar}
                                onDelete={equipamentosCatalogo.remover}
                            />

                            {!props.hideDateEmission && (
                                <InputV2
                                    marginBottom="36px"
                                    id="dataemissao"
                                    minHeight="50px"
                                    onChange={e => changeDate(e)}
                                    label="Data de emissão"
                                    mask="99/99/9999"
                                    value={date}
                                    disabled={props.index > 0 ? true : false}
                                    type="date"
                                />
                            )}
                        </>
                    ) : (null)}
                </>
            )}
        </>
    )
}

export default Relation;
